<!-- 載入圖示 -->
<template>
  <div>
    <div id="loading" :class="{ displayNone: loadingDisplay }">
      <div class="loading">
        <span>Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  data () {
    return {
      loadingDisplay: false,
      LoadingTimerKey: ''
    }
  },
  mounted: function () {
    const vm = this
    this.LoadingTimerKey = setTimeout(function () {
      vm.loadingDisplay = true
    }, 2000)
  },
  beforeDestroy () {
    clearInterval(this.LoadingTimerKey)
  }
}
</script>

<style scoped lang="scss">
.displayNone {
  display: none !important;
}
#loading {
  margin: 0;
  padding: 0;
  background: #34495e;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
}
.loading {
  width: 200px;
  height: 200px;
  box-sizing: border-box;
  border-radius: 50%;
  border-top: 10px solid #e74c3c;
  position: relative;
  animation: a1 2s linear infinite;
}
.loading::before,
.loading::after {
  content: "";
  width: 200px;
  height: 200px;
  position: absolute;
  left: 0;
  top: -10px;
  box-sizing: border-box;
  border-radius: 50%;
}
.loading::before {
  border-top: 10px solid #e67e22;
  transform: rotate(120deg);
}
.loading::after {
  border-top: 10px solid #3498db;
  transform: rotate(240deg);
}
.loading span {
  position: absolute;
  width: 200px;
  height: 200px;
  color: #000;
  text-align: center;
  line-height: 200px;
  animation: a2 2s linear infinite;
}
@keyframes a1 {
  to {
    transform: rotate(360deg);
  }
}
@keyframes a2 {
  to {
    transform: rotate(-360deg);
  }
}
</style>
